module.exports = __webpack_public_path__ + "img/yblogin_logo.a49adc94.png";